export class RegistrationRequest {
	oneRosterApiUrl: string;
	oneRosterApiVersion: string;
	oauthVersion: string;
	oauthClientId: string;
	oauthClientSecret: string;
	syncCrunJob: string;
	oauthTokenEndpoint: string;

	constructor() {
		this.oneRosterApiUrl = '';
		this.oneRosterApiVersion = '';
		this.oauthVersion = '';
		this.oauthClientId = '';
		this.oauthClientSecret = '';
		this.syncCrunJob = '0 22 * * *';
		this.oauthTokenEndpoint = '';
	}
}
